/**
 * Villy Shop listing: <vs-quick-add> (tile chip), <vs-listing> (server-side filter and sort drawer, Show more, toolbar, dock, URL), <vs-tabs>.
 * Depends on vs-core.js (window.VillyShop). Loaded by every section that shows tiles; safe to load twice.
 */
(function () {
  'use strict';
  if (window.__vsListingLoaded) return;
  window.__vsListingLoaded = true;

  var doc = document;
  var root = doc.documentElement;
  var VS = function () { return window.VillyShop || {}; };
  var CHECK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var BAG = '<svg class="vs-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.4 9h11.2l-.9 10.4H7.3z"/><path d="M9.5 9V7.9a2.5 2.5 0 0 1 5 0V9"/><path d="M12 12.3v4.4M9.8 14.5h4.4"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  var ICON_CHEV = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
  var ICON_SLIDERS = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h9M17 8h3M4 16h3M11 16h9"/><circle cx="15" cy="8" r="2"/><circle cx="9" cy="16" r="2"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mqPhone() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }

  /* ====================================================================== quick add (tile chip) */
  class VsQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      var self = this;
      this.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); self.run(); });
    }
    run() {
      var btn = this.querySelector('button');
      if (!btn || btn.classList.contains('is-loading')) return;
      if (btn.getAttribute('data-personalised') === 'true') { window.location.href = btn.getAttribute('data-product-url'); return; }
      if (btn.getAttribute('data-single') !== 'true') { openQuickBuy(btn.getAttribute('data-product-url'), btn); return; }
      var id = Number(btn.getAttribute('data-variant-id'));
      if (!window.VillyTheme || !id) { window.location.href = btn.getAttribute('data-product-url'); return; }
      var icon = btn.querySelector('.vs-qa__icon');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      window.VillyTheme.addToCart(id, 1).then(function () {
        if (icon) icon.innerHTML = CHECK;
        btn.classList.add('is-added');
        if (VS().live) VS().live('Added to your basket');
        window.setTimeout(function () { if (icon) icon.innerHTML = BAG; btn.classList.remove('is-added'); }, 1500);
      }).catch(function (error) {
        if (VS().live) VS().live((error && error.message) || 'Sorry, that could not be added. Please try again.');
      }).then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
    }
  }
  if (!customElements.get('vs-quick-add')) customElements.define('vs-quick-add', VsQuickAdd);

  /* ====================================================================== quick buy dialog (products with options) */
  function qbDialog() {
    var dlg = doc.querySelector('dialog.vs-quickbuy');
    if (dlg) return dlg;
    dlg = doc.createElement('dialog');
    dlg.className = 'vs-dlg vs-quickbuy';
    dlg.setAttribute('aria-label', 'Quick buy');
    dlg.innerHTML = '<div class="vs-dlg__overlay" data-vs-close-overlay><div class="vs-quickbuy__card">' +
      '<button type="button" class="vs-dlg__close" data-vs-qb-close aria-label="Close">' + ICON_X.replace(/16/g, '24') + '</button>' +
      '<div class="vs-quickbuy__loading" data-vs-qb-body>Loading…</div></div></div>';
    doc.body.appendChild(dlg);
    dlg.addEventListener('click', function (event) {
      if (event.target === event.target.closest('[data-vs-close-overlay]') || event.target.closest('[data-vs-qb-close]')) VS().closeDialog(dlg);
    });
    return dlg;
  }
  function openQuickBuy(url, trigger) {
    var dlg = qbDialog();
    var body = dlg.querySelector('[data-vs-qb-body]');
    body.className = 'vs-quickbuy__loading';
    body.textContent = 'Loading…';
    VS().openDialog(dlg);
    dlg.__trigger = trigger;
    dlg.addEventListener('vs:close', function onClose() { dlg.removeEventListener('vs:close', onClose); if (dlg.__trigger) dlg.__trigger.focus({ preventScroll: true }); }, { once: true });
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=villy-quick-buy', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['villy-quick-buy'];
        var parsed = new DOMParser().parseFromString(html || '', 'text/html');
        var content = parsed.querySelector('[data-vs-qb]');
        if (!content) throw new Error('empty');
        body.className = '';
        body.innerHTML = '';
        body.appendChild(doc.importNode(content, true));
        initQuickBuy(body, dlg);
      })
      .catch(function () { window.location.href = url; });
  }
  function initQuickBuy(scope, dlg) {
    var form = scope.querySelector('[data-vs-qb-form]');
    if (!form) return;
    var json = scope.querySelector('[data-vs-qb-variants]');
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }
    var btn = form.querySelector('[data-vs-qb-add]');
    var label = btn.querySelector('span');
    var price = btn.querySelector('[data-vs-qb-price]');
    var error = form.querySelector('[data-vs-qb-error]');
    var current = null;
    function money(cents) {
      var cfg = window.VILLY_CONFIG || {};
      try { return new Intl.NumberFormat(cfg.locale || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP' }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); }
    }
    function pick() {
      var chosen = Array.prototype.map.call(form.querySelectorAll('fieldset'), function (fs) {
        var c = fs.querySelector('input:checked');
        var name = fs.querySelector('[data-vs-qb-val]');
        if (name && c) name.textContent = c.value;
        return c ? c.value : null;
      });
      current = variants.filter(function (v) { return v.options.every(function (o, i) { return chosen[i] === o; }); })[0] || null;
      if (current) {
        price.textContent = money(current.price);
        btn.disabled = !current.available;
        label.textContent = current.available ? 'Add to basket' : 'Sold out';
      } else {
        btn.disabled = true; label.textContent = 'Unavailable';
      }
    }
    form.addEventListener('change', pick);
    pick();
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!current || !current.available || !window.VillyTheme) return;
      btn.classList.add('is-loading');
      error.textContent = '';
      window.VillyTheme.addToCart(current.id, 1).then(function () {
        VS().closeDialog(dlg);
      }).catch(function (e) { error.textContent = (e && e.message) || 'Sorry, that could not be added.'; }).then(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ====================================================================== listing */
  /* A listing is server-rendered and server-filtered: Shopify does the filtering, sorting and paging (so it works for any size of
     catalogue); this element only (1) fetches the same page again with the Section Rendering API (?section_id=) and swaps the
     [data-vs-results] block, (2) appends the next page for "Show more", and (3) draws the filter and sort drawer from the JSON model
     that vs-filter-model.liquid prints. Every address stays a normal collection address, so links, back and reload all work. */
  var SKIP_PARAMS = ['page', 'section_id', 'view', 'phcursor', 'pageby'];
  var P_GTE = 'filter.v.price.gte';
  var P_LTE = 'filter.v.price.lte';
  var P_AVAIL = 'filter.v.availability';

  function num(v) { if (v == null || v === '') return null; var n = Number(v); return isNaN(n) ? null : n; }
  function trimNum(n) { return String(Math.round(n * 100) / 100); }
  function sameNum(a, b) { if (a == null || b == null) return a == null && b == null; return Math.abs(a - b) < 0.005; }
  function getParams(search) {
    var q = new URLSearchParams(search == null ? window.location.search : search);
    SKIP_PARAMS.forEach(function (k) { q.delete(k); });
    return q;
  }
  /* the words of a search stay when every filter is reset */
  var KEEP_PARAMS = ['q', 'type', 'options[prefix]', 'options[unavailable_products]', 'options[fields]'];
  function keepOnly(q) {
    var out = new URLSearchParams();
    KEEP_PARAMS.forEach(function (k) { q.getAll(k).forEach(function (v) { out.append(k, v); }); });
    return out;
  }
  function toggleParam(q, name, value) {
    var values = q.getAll(name);
    var at = values.indexOf(value);
    if (at > -1) values.splice(at, 1); else values.push(value);
    q.delete(name);
    values.forEach(function (v) { q.append(name, v); });
  }
  function removeParam(q, name, value) {
    var values = q.getAll(name).filter(function (v) { return v !== value; });
    q.delete(name);
    values.forEach(function (v) { q.append(name, v); });
  }
  function sessionGet(key) { try { return JSON.parse(window.sessionStorage.getItem(key)); } catch (e) { return null; } }
  function sessionSet(key, value) { try { if (value == null) window.sessionStorage.removeItem(key); else window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage can be blocked */ } }

  class VsListing extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.sectionId = this.getAttribute('data-section-id') || '';
      this.dlg = this.querySelector('[data-vs-filter]');
      this.bar = this.querySelector('[data-vs-bar]');
      this.dock = this.querySelector('[data-vs-dock]');
      this.rail = this.querySelector('[data-vs-dock-rail]');
      this.view = 'root';
      this.extra = 0;
      this.req = 0;
      this.lastSearch = window.location.search;
      this.readModel();
      this.bind();
      this.paint(false);
      this.onScroll = this.scroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.scroll();
      this.restore();
    }
    disconnectedCallback() {
      this.__ready = false;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('popstate', this.onPop);
      window.removeEventListener('pagehide', this.onHide);
      if (this.dlg && this.dlg.open) VS().closeDialog(this.dlg, true);
    }

    /* ---------- the model printed by vs-filter-model.liquid ---------- */
    readModel() {
      var el = this.querySelector('script[data-vs-model]');
      var m = null;
      try { m = JSON.parse(el.textContent); } catch (e) { m = null; }
      this.model = this.tidy(m);
    }
    tidy(m) {
      m = m || {};
      var groups = [];
      (m.groups || []).forEach(function (g) {
        var at = -1;
        groups.forEach(function (x, i) { if (x.key === g.key) at = i; });
        if (at < 0) groups.push(g);
        else if ((g.rows || []).length > (groups[at].rows || []).length) groups[at] = g;
      });
      return {
        count: m.count || 0, sort: m.sort || '', defaultSort: m.defaultSort || '', sorts: m.sorts || [], groups: groups, avail: m.avail || null,
        price: m.price || { min: null, max: null, rangeMax: 0, steps: [] }
      };
    }
    countsOf(model) {
      var out = {};
      model.groups.forEach(function (g) { out[g.key] = {}; g.rows.forEach(function (r) { out[g.key][r.v] = r.n; }); });
      return out;
    }

    /* ---------- filter state read from a query string ---------- */
    sortName(v) {
      var hit = this.model.sorts.filter(function (s) { return s.v === v; })[0];
      return hit ? hit.l : '';
    }
    bands() {
      if (!(this.model.price.rangeMax > 0)) return [];
      var steps = (this.model.price.steps || []).filter(function (n) { return n > 0; });
      if (!steps.length) return [];
      var out = [];
      var lo = 0;
      steps.forEach(function (hi) { out.push({ lo: lo, hi: hi }); lo = hi; });
      out.push({ lo: lo, hi: null });
      return out;
    }
    bandParams(b) { return { gte: b.lo > 0 ? b.lo : null, lte: b.hi != null ? Math.round((b.hi - 0.01) * 100) / 100 : null }; }
    money(n) {
      var cfg = window.VILLY_CONFIG || {};
      var whole = Math.abs(n - Math.round(n)) < 0.005;
      try { return new Intl.NumberFormat(cfg.locale || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(n); } catch (e) { return '£' + trimNum(n); }
    }
    priceLabel(gte, lte) {
      var lo = num(gte); var hi = num(lte);
      if (lo == null && hi == null) return '';
      var edge = hi != null ? Math.round((hi + 0.01) * 100) / 100 : null;
      var bandEdge = edge != null && Math.abs(edge - Math.round(edge)) < 0.005;
      if (lo == null || lo === 0) return hi == null ? '' : (bandEdge ? 'Under ' + this.money(edge) : 'Up to ' + this.money(hi));
      if (hi == null) return 'Over ' + this.money(lo);
      return this.money(lo) + ' to ' + this.money(bandEdge ? edge : hi);
    }
    activeList(q) {
      var out = [];
      this.model.groups.forEach(function (g) {
        var values = q.getAll(g.param);
        g.rows.forEach(function (r) { if (values.indexOf(r.v) > -1) out.push({ g: g.param, v: r.v, label: r.l }); });
        values.forEach(function (v) { if (!g.rows.some(function (r) { return r.v === v; })) out.push({ g: g.param, v: v, label: v.replace(/^[a-z]+:/, '') }); });
      });
      if (this.model.avail && q.getAll(this.model.avail.param).indexOf('1') > -1) out.push({ g: this.model.avail.param, v: '1', label: 'Available now' });
      var gte = q.get(P_GTE); var lte = q.get(P_LTE);
      if (num(gte) != null || num(lte) != null) out.push({ g: 'price', v: '', label: this.priceLabel(gte, lte) });
      return out;
    }
    filtersOn(q) { return this.activeList(q).length; }
    sortIsDefault(q) {
      var s = q.get('sort_by');
      return !s || s === this.model.defaultSort;
    }

    /* ---------- fetch / swap / navigate ---------- */
    fetchListing(search, pageUrl) {
      var url = pageUrl ? new URL(pageUrl, window.location.href) : new URL(window.location.pathname + (search ? '?' + search : ''), window.location.href);
      url.searchParams.set('section_id', this.sectionId);
      return fetch(url.pathname + '?' + url.searchParams.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var listing = parsed.querySelector('vs-listing');
          if (!listing) throw new Error('no listing in the answer');
          return listing;
        });
    }
    setBusy(on) {
      var results = this.querySelector('[data-vs-results]');
      if (results) { if (on) results.setAttribute('aria-busy', 'true'); else results.removeAttribute('aria-busy'); }
      this.classList.toggle('is-busy', !!on);
    }
    swap(next) {
      var cur = this.querySelector('[data-vs-results]');
      var inc = next.querySelector('[data-vs-results]');
      if (!cur || !inc) throw new Error('nothing to swap');
      cur.replaceWith(doc.importNode(inc, true));
      this.extra = 0;
      this.readModel();
    }
    /* mode: push (default), replace or none (the address already changed: back / forward) */
    load(search, mode, quiet) {
      var self = this;
      var id = ++this.req;
      this.setBusy(true);
      return this.fetchListing(search).then(function (next) {
        if (id !== self.req) return;
        self.swap(next);
        var url = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
        if (mode !== 'none') { try { window.history[mode === 'replace' ? 'replaceState' : 'pushState']({ vsListing: 1 }, '', url); } catch (e) { /* ignore */ } }
        self.lastSearch = search ? '?' + search : '';
        self.setBusy(false);
        self.paint(!quiet);
        if (!quiet) self.scrollToGrid();
      }).catch(function () {
        window.location.href = window.location.pathname + (search ? '?' + search : '');
      });
    }
    scrollToGrid() {
      var anchor = this.bar || this.querySelector('[data-vs-results]');
      if (!anchor) return;
      var stick = parseFloat(getComputedStyle(root).getPropertyValue('--vs-stick')) || 0;
      var top = anchor.getBoundingClientRect().top + window.scrollY - stick - 8;
      if (window.scrollY > top) window.scrollTo({ top: Math.max(0, top), behavior: VS().reduceMotion && VS().reduceMotion.matches ? 'auto' : 'smooth' });
    }

    /* ---------- "Show more" ---------- */
    loadMore(btn, quiet) {
      var self = this;
      if (this.loadingMore) return Promise.resolve();
      this.loadingMore = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      return this.fetchListing(null, btn.getAttribute('href')).then(function (next) {
        var grid = self.querySelector('[data-vs-grid]');
        var more = next.querySelector('[data-vs-grid]');
        var wrap = self.querySelector('[data-vs-more-wrap]');
        var fresh = next.querySelector('[data-vs-more-wrap]');
        var added = [];
        if (grid && more) {
          Array.prototype.slice.call(more.children).forEach(function (node, i) {
            var copy = doc.importNode(node, true);
            if (!quiet) { copy.classList.add('is-new'); copy.style.setProperty('--vs-new-i', String(Math.min(i, 8))); }
            grid.appendChild(copy);
            added.push(copy);
          });
        }
        if (wrap) { if (fresh) wrap.replaceWith(doc.importNode(fresh, true)); else wrap.remove(); }
        self.extra += 1;
        window.setTimeout(function () { added.forEach(function (n) { n.classList.remove('is-new'); n.style.removeProperty('--vs-new-i'); }); }, 900);
        var shown = fresh ? Number(fresh.getAttribute('data-shown')) : self.model.count;
        var total = fresh ? Number(fresh.getAttribute('data-total')) : self.model.count;
        if (!quiet) {
          var first = added.filter(function (n) { return n.querySelector && n.querySelector('a[href]'); })[0];
          var link = first && first.querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
          if (VS().live) VS().live('Showing ' + shown + ' of ' + total + ' pieces');
        }
      }).catch(function () {
        window.location.href = btn.getAttribute('href');
      }).then(function () { self.loadingMore = false; });
    }
    saveSpot() {
      var key = 'vs-list:' + window.location.pathname + this.lastSearch;
      if (this.extra > 0) sessionSet(key, { extra: this.extra, y: Math.round(window.scrollY) }); else sessionSet(key, null);
    }
    /* back from a product page: bring the pages that were open back and return to the same spot */
    restore() {
      var self = this;
      this.onPop = function () {
        if (window.location.search === self.lastSearch) return;
        self.load(window.location.search.replace(/^\?/, ''), 'none', false);
      };
      this.onHide = function () { self.saveSpot(); };
      window.addEventListener('popstate', this.onPop);
      window.addEventListener('pagehide', this.onHide);
      var entries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : [];
      if (!entries.length || entries[0].type !== 'back_forward') return;
      var key = 'vs-list:' + window.location.pathname + this.lastSearch;
      var saved = sessionGet(key);
      sessionSet(key, null);
      if (!saved || !(saved.extra > 0)) return;
      var left = Math.min(saved.extra, 12);
      try { window.history.scrollRestoration = 'manual'; } catch (e) { /* ignore */ }
      this.setBusy(true);
      var step = function () {
        var btn = self.querySelector('[data-vs-more]');
        if (left <= 0 || !btn) return Promise.resolve();
        left -= 1;
        return self.loadMore(btn, true).then(step);
      };
      step().then(function () {
        self.setBusy(false);
        window.scrollTo(0, saved.y || 0);
        try { window.history.scrollRestoration = 'auto'; } catch (e) { /* ignore */ }
      });
    }

    /* ---------- painting the parts outside the swapped block ---------- */
    paint(announce) {
      var q = getParams();
      var m = this.model;
      var on = this.filtersOn(q);
      var word = m.count === 1 ? 'piece' : 'pieces';
      var countEl = this.querySelector('[data-vs-count]');
      var text = m.count + ' ' + word;
      if (countEl) countEl.textContent = text;
      var n = on + (this.sortIsDefault(q) ? 0 : 1);
      Array.prototype.forEach.call(this.querySelectorAll('[data-vs-active-n]'), function (el) { el.textContent = n ? '(' + n + ')' : ''; });
      var chips = this.activeList(q);
      var chipsHtml = chips.map(function (c) { return chipHtml(c); }).join('');
      var chipsEl = this.querySelector('[data-vs-chips]');
      if (chipsEl) chipsEl.innerHTML = chipsHtml;
      if (this.rail) {
        var html = '<span class="vs-dock__count">' + esc(text) + '</span>' + chipsHtml;
        this.rail.innerHTML = html;
      }
      if (announce && VS().live && !(this.dlg && this.dlg.open)) VS().live(text);
    }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      this.addEventListener('click', function (event) {
        var t = event.target;
        var open = t.closest('[data-vs-open-filter]');
        if (open) { self.openDrawer(open); return; }
        var rm = t.closest('[data-vs-remove]');
        if (rm) { self.removeChip(rm.getAttribute('data-vs-remove'), rm.getAttribute('data-v')); return; }
        var more = t.closest('[data-vs-more]');
        if (more) { event.preventDefault(); self.loadMore(more, false); return; }
        var reset = t.closest('[data-vs-reset-link]');
        if (reset) { event.preventDefault(); self.load(keepOnly(getParams()).toString(), 'push'); return; }
      });
      if (this.dlg) {
        this.dlg.addEventListener('click', function (event) {
          var t = event.target;
          if (t === t.closest('[data-vs-close-overlay]') || t.closest('[data-vs-filter-close]')) { VS().closeDialog(self.dlg); return; }
          if (t.closest('[data-vs-filter-apply]')) { self.applyDraft(); return; }
          if (t.closest('[data-vs-reset]')) { self.resetDraft(); return; }
          /* every render replaces the body, so the focus is handed back explicitly: back -> the row that opened the view, open -> the chosen
             (else first) option, choose / toggle -> the same control */
          if (t.closest('[data-vs-view-back]')) { var from = self.view; self.view = 'root'; self.renderDrawer(true, '[data-vs-go="' + from + '"]'); return; }
          var go = t.closest('[data-vs-go]');
          if (go) { self.view = go.getAttribute('data-vs-go'); self.renderDrawer(true, '[data-vs-opt][aria-checked="true"], [data-vs-opt]'); return; }
          var opt = t.closest('[data-vs-opt]');
          if (opt) { self.choose(opt); return; }
          var av = t.closest('[data-vs-avail]');
          if (av) { self.toggleAvail(); }
        });
        this.dlg.addEventListener('vs:close', function () {
          if (self.opener) self.opener.focus({ preventScroll: true });
          self.draft = null;
        });
      }
      var types = this.querySelector('.vs-types .vs-car__track');
      var progress = this.querySelector('.vs-types__progress span');
      if (types && progress) {
        var upd = function () {
          var ratio = types.clientWidth / Math.max(1, types.scrollWidth);
          progress.style.width = Math.min(100, ratio * 100) + '%';
          progress.style.left = (types.scrollLeft / Math.max(1, types.scrollWidth) * 100) + '%';
        };
        types.addEventListener('scroll', upd, { passive: true });
        upd();
      }
    }
    removeChip(g, v) {
      var q = getParams();
      if (g === 'price') { q.delete(P_GTE); q.delete(P_LTE); } else removeParam(q, g, v);
      this.load(q.toString(), 'push');
    }
    scroll() {
      var self = this;
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(function () {
        self.ticking = false;
        if (self.bar) {
          var stick = parseFloat(getComputedStyle(root).getPropertyValue('--vs-stick')) || 0;
          var top = self.bar.getBoundingClientRect().top;
          self.bar.toggleAttribute('data-stuck', top <= stick + 1 && window.scrollY > 40);
        }
        if (self.dock) {
          self.dock.classList.toggle('is-scrolled', window.scrollY > 240);
          var pill = self.dock.querySelector('.vs-dock__pill');
          if (pill) {
            var shift = Math.max(0, (self.dock.clientWidth - pill.offsetWidth) / 2 - 8);
            self.dock.style.setProperty('--vs-pill-shift', shift + 'px');
          }
        }
      });
    }

    /* ---------- the drawer ---------- */
    openDrawer(opener) {
      if (!this.dlg) return;
      this.opener = opener;
      this.view = 'root';
      this.draft = getParams();
      this.dmodel = this.model;
      this.renderDrawer(false);
      VS().openDialog(this.dlg);
      var x = this.dlg.querySelector('[data-vs-filter-close]');
      if (x) x.focus({ preventScroll: true });
    }
    draftOn() { return this.filtersOn(this.draft) + (this.sortIsDefault(this.draft) ? 0 : 1); }
    hint(key) {
      var q = this.draft; var self = this;
      if (key === 'sort') return this.sortName(q.get('sort_by') || this.model.defaultSort) || '';
      if (key === 'price') return this.priceLabel(q.get(P_GTE), q.get(P_LTE));
      var g = this.model.groups.filter(function (x) { return x.key === key; })[0];
      if (!g) return '';
      var values = q.getAll(g.param);
      var rows = g.rows.filter(function (r) { return values.indexOf(r.v) > -1; });
      if (!rows.length) return '';
      return rows.length === 1 ? rows[0].l : rows.length + ' selected';
    }
    rowHtml(kind, g, r, on) {
      /* kind: box (checkbox) or radio */
      var count = r.n != null ? '<span class="vs-frow__count">' + r.n + '</span>' : '';
      var dead = r.n === 0 && !on;
      if (kind === 'radio') {
        return '<button type="button" class="vs-frow vs-frow--option vs-frow--check" role="radio" aria-checked="' + on + '" data-vs-opt="' + esc(g) + '" data-v="' + esc(r.v) + '"><span class="vs-frow__ctl vs-frow__ctl--radio"></span><span>' + esc(r.l) + '</span></button>';
      }
      return '<button type="button" class="vs-frow vs-frow--option vs-frow--check' + (dead ? ' is-zero' : '') + '" role="checkbox" aria-checked="' + on + '"' + (dead ? ' aria-disabled="true"' : '') + ' data-vs-opt="' + esc(g) + '" data-v="' + esc(r.v) + '"><span class="vs-frow__ctl vs-frow__ctl--box">' + (on ? CHECK.replace(/20/g, '14') : '') + '</span>' +
        (r.hex ? '<span class="vs-frow__dot" style="background:' + esc(r.hex) + '"></span>' : '') + '<span>' + esc(r.l) + '</span>' + count + '</button>';
    }
    renderDrawer(animate, focusSel) {
      var body = this.dlg && this.dlg.querySelector('[data-vs-filter-body]');
      if (!body || !this.draft) return;
      var self = this; var q = this.draft; var m = this.model;
      var back = this.dlg.querySelector('[data-vs-view-back]');
      var title = this.dlg.querySelector('[data-vs-filter-title]');
      var counts = this.countsOf(this.dmodel || m);
      var html = '';
      var groupAttr = '';
      if (this.view === 'root') {
        back.hidden = true;
        title.textContent = 'Filter & sort';
        if (m.avail) {
          var availOn = q.getAll(m.avail.param).indexOf('1') > -1;
          html += '<button type="button" class="vs-frow vs-frow--check" role="checkbox" aria-checked="' + availOn + '" data-vs-avail><span class="vs-frow__ctl vs-frow__ctl--box">' + (availOn ? CHECK.replace(/20/g, '14') : '') + '</span><span>Available now</span></button>';
        }
        if (m.sorts.length > 1) html += '<button type="button" class="vs-frow" data-vs-go="sort"><span>Sort by</span><span class="vs-frow__hint">' + esc(this.hint('sort')) + '</span>' + ICON_CHEV + '</button>';
        m.groups.forEach(function (g) {
          html += '<button type="button" class="vs-frow" data-vs-go="' + esc(g.key) + '"><span>' + esc(g.title) + '</span><span class="vs-frow__hint">' + esc(self.hint(g.key)) + '</span>' + ICON_CHEV + '</button>';
        });
        if (self.bands().length) html += '<button type="button" class="vs-frow" data-vs-go="price"><span>Price</span><span class="vs-frow__hint">' + esc(self.hint('price')) + '</span>' + ICON_CHEV + '</button>';
      } else {
        back.hidden = false;
        var key = this.view;
        var group = m.groups.filter(function (x) { return x.key === key; })[0];
        title.textContent = key === 'sort' ? 'Sort by' : key === 'price' ? 'Price' : (group ? group.title : '');
        groupAttr = ' role="' + (key === 'sort' || key === 'price' ? 'radiogroup' : 'group') + '" aria-label="' + esc(title.textContent) + '"';
        if (key === 'sort') {
          var cur = q.get('sort_by') || m.defaultSort;
          html = m.sorts.map(function (s) { return self.rowHtml('radio', 'sort', { v: s.v, l: s.l }, cur === s.v); }).join('');
        } else if (key === 'price') {
          var gte = num(q.get(P_GTE)); var lte = num(q.get(P_LTE));
          var hit = false;
          var rows = this.bands().map(function (b, i) {
            var p = self.bandParams(b);
            var on = (gte != null || lte != null) && sameNum(gte, p.gte) && sameNum(lte, p.lte);
            if (on) hit = true;
            return self.rowHtml('radio', 'price', { v: String(i), l: self.priceLabel(p.gte, p.lte) }, on);
          });
          if ((gte != null || lte != null) && !hit) rows.unshift(self.rowHtml('radio', 'price', { v: 'custom', l: self.priceLabel(q.get(P_GTE), q.get(P_LTE)) }, true));
          html = rows.join('');
        } else if (group) {
          var values = q.getAll(group.param);
          var seen = {};
          html = group.rows.map(function (r) {
            seen[r.v] = true;
            var row = { v: r.v, l: r.l, hex: r.hex, n: (counts[group.key] || {})[r.v] };
            if (row.n == null) row.n = 0;
            return self.rowHtml('box', group.key, row, values.indexOf(r.v) > -1);
          }).join('');
        }
      }
      body.innerHTML = '<div class="vs-filter__view"' + groupAttr + (animate === false ? ' style="animation:none"' : '') + '>' + html + '</div>';
      this.paintDrawerFooter();
      if (focusSel) {
        var target = this.dlg.querySelector(focusSel);
        if (target) target.focus({ preventScroll: true });
      }
    }
    choose(el) {
      var key = el.getAttribute('data-vs-opt'); var v = el.getAttribute('data-v'); var q = this.draft; var m = this.model;
      if (el.getAttribute('aria-disabled') === 'true') return;
      if (key === 'sort') {
        if (v === m.defaultSort) q.delete('sort_by'); else q.set('sort_by', v);
      } else if (key === 'price') {
        var gte = num(q.get(P_GTE)); var lte = num(q.get(P_LTE));
        q.delete(P_GTE); q.delete(P_LTE);
        if (v !== 'custom') {
          var p = this.bandParams(this.bands()[Number(v)]);
          var same = (gte != null || lte != null) && sameNum(gte, p.gte) && sameNum(lte, p.lte);
          if (!same) {
            if (p.gte != null) q.set(P_GTE, trimNum(p.gte));
            if (p.lte != null) q.set(P_LTE, trimNum(p.lte));
          }
        }
      } else {
        var g = m.groups.filter(function (x) { return x.key === key; })[0];
        if (g) toggleParam(q, g.param, v);
      }
      this.renderDrawer(false, '[data-vs-opt="' + key + '"][data-v="' + String(v).replace(/(["\\])/g, '\\$1') + '"]');
      this.preview();
    }
    toggleAvail() {
      toggleParam(this.draft, this.model.avail.param, '1');
      this.renderDrawer(false, '[data-vs-avail]');
      this.preview();
    }
    resetDraft() {
      /* the Reset button turns disabled once everything is cleared: hand the focus on to the primary button instead of losing it */
      var inDrawer = !!(this.dlg && this.dlg.contains(doc.activeElement));
      this.draft = keepOnly(getParams());
      this.renderDrawer(false, inDrawer ? '[data-vs-filter-apply]' : null);
      this.preview();
    }
    /* what would the page show? ask the server, then fix the counts of the open drawer in place */
    preview() {
      var self = this;
      var id = ++this.previewId || (this.previewId = 1);
      window.clearTimeout(this.previewTimer);
      this.pending = true;
      this.paintDrawerFooter();
      this.previewTimer = window.setTimeout(function () {
        self.fetchListing(self.draft.toString()).then(function (next) {
          if (id !== self.previewId || !self.draft) return;
          var el = next.querySelector('script[data-vs-model]');
          self.dmodel = self.tidy(JSON.parse(el.textContent));
          self.pending = false;
          self.refreshCounts();
          self.paintDrawerFooter();
        }).catch(function () {
          if (id !== self.previewId) return;
          self.dmodel = null;
          self.pending = false;
          self.paintDrawerFooter();
        });
      }, 220);
    }
    refreshCounts() {
      var counts = this.countsOf(this.dmodel || this.model);
      Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-frow--option[role="checkbox"][data-vs-opt]'), function (row) {
        var key = row.getAttribute('data-vs-opt'); var v = row.getAttribute('data-v');
        var n = (counts[key] || {})[v];
        if (n == null) n = 0;
        var cEl = row.querySelector('.vs-frow__count');
        if (cEl) cEl.textContent = String(n);
        var dead = n === 0 && row.getAttribute('aria-checked') !== 'true';
        row.classList.toggle('is-zero', dead);
        if (dead) row.setAttribute('aria-disabled', 'true'); else row.removeAttribute('aria-disabled');
      });
    }
    applyDraft() {
      var q = this.draft;
      VS().closeDialog(this.dlg);
      if (!q) return;
      var next = q.toString();
      if (next === getParams().toString()) return;
      this.load(next, 'push');
    }
    paintDrawerFooter() {
      if (!this.dlg || !this.draft) return;
      var apply = this.dlg.querySelector('[data-vs-filter-apply]');
      var same = this.draft.toString() === getParams().toString();
      var model = same ? this.model : this.dmodel;
      if (apply) {
        if (this.pending && !same) apply.textContent = 'See the pieces';
        else if (!model) apply.textContent = 'See the pieces';
        else apply.textContent = model.count === 1 ? 'See the 1 piece' : 'See the ' + model.count + ' pieces';
        apply.disabled = !!(model && model.count === 0 && !same);
      }
      var reset = this.dlg.querySelector('[data-vs-reset]');
      if (reset) reset.disabled = this.draftOn() === 0;
      /* hints on the root rows follow the draft */
    }
  }
  if (!customElements.get('vs-listing')) customElements.define('vs-listing', VsListing);

  function chipHtml(c) {
    return '<button type="button" class="vs-chip vs-chip--paper vs-chip--x" data-vs-remove="' + esc(c.g) + '" data-v="' + esc(c.v) + '" aria-label="Remove ' + esc(c.label) + '"><span>' + esc(c.label) + '</span>' + ICON_X + '</button>';
  }

  /* ====================================================================== curated page tabs */
  class VsTabs extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.links = Array.prototype.slice.call(this.querySelectorAll('[data-vs-tab-link]'));
      var self = this;
      this.links.forEach(function (a) {
        a.addEventListener('click', function (event) {
          var target = doc.querySelector(a.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: VS().reduceMotion && VS().reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
          self.mark(a);
        });
      });
      this.onScroll = function () {
        if (self.ticking) return;
        self.ticking = true;
        window.requestAnimationFrame(function () {
          self.ticking = false;
          var line = (parseFloat(getComputedStyle(root).getPropertyValue('--vs-stick')) || 0) + 140;
          var current = self.links[0];
          self.links.forEach(function (a) {
            var t = doc.querySelector(a.getAttribute('href'));
            if (t && t.getBoundingClientRect().top <= line) current = a;
          });
          self.mark(current);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    disconnectedCallback() { this.__ready = false; window.removeEventListener('scroll', this.onScroll); }
    mark(active) {
      this.links.forEach(function (a) { if (a === active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (active && active.scrollIntoView && this.scrollWidth > this.clientWidth) active.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
  }
  if (!customElements.get('vs-tabs')) customElements.define('vs-tabs', VsTabs);
  void ICON_SLIDERS;
})();
